import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search, Plus, ArrowDownAZ, ArrowUpAZ, ChevronRight, Users } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { api, LEVELS } from "../lib/api";
import { Avatar, Empty, LevelBadge, Loader, PageHeader, PillTabs } from "../components/common";
import { AthleteForm } from "./AthleteProfile";

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function Athletes() {
  const { isAdmin } = useAuth();
  const [list, setList] = useState(null);
  const [q, setQ] = useState("");
  const [level, setLevel] = useState("");
  const [letter, setLetter] = useState("");
  const [sort, setSort] = useState("az");
  const [open, setOpen] = useState(false);
  const load = () => api.get("/athletes", { params: { q, level, letter, sort } }).then((r) => setList(r.data));
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [q, level, letter, sort]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <PageHeader eyebrow="Comunidade" title="Atletas" subtitle="Encontre e interaja com os inscritos do circuito."
        action={isAdmin && <button data-testid="new-athlete-btn" onClick={() => setOpen(true)} className="btn-lime flex items-center gap-2 rounded-full px-5 py-2.5 text-sm"><Plus className="h-4 w-4" />Novo atleta</button>} />
      <div className="mb-3 flex gap-2">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-3.5 h-4 w-4 text-[#64748B]" />
          <input data-testid="athlete-search-input" className="inp pl-9" placeholder="Buscar atleta por nome, Instagram ou e-mail..." value={q} onChange={(e) => setQ(e.target.value)} />
        </div>
        <button data-testid="athlete-sort-btn" onClick={() => setSort(sort === "az" ? "za" : "az")} className="btn-ghost flex items-center gap-1">
          {sort === "az" ? <ArrowDownAZ className="h-4 w-4" /> : <ArrowUpAZ className="h-4 w-4" />}{sort === "az" ? "A-Z" : "Z-A"}
        </button>
      </div>
      <PillTabs testid="athlete-level" tabs={[{ value: "", label: "Todos" }, ...LEVELS]} value={level} onChange={setLevel} />
      <div className="no-scrollbar my-3 flex gap-1 overflow-x-auto">
        <button data-testid="letter-all" onClick={() => setLetter("")} className={`h-8 min-w-8 rounded-lg px-2 text-xs font-bold ${!letter ? "bg-[#E4F222] text-black" : "text-[#64748B]"}`}>#</button>
        {LETTERS.map((l) => (
          <button key={l} data-testid={`letter-${l}`} onClick={() => setLetter(letter === l ? "" : l)} className={`h-8 w-8 shrink-0 rounded-lg text-xs font-bold ${letter === l ? "bg-[#E4F222] text-black" : "text-[#64748B] hover:text-white"}`}>{l}</button>
        ))}
      </div>
      {!list ? <Loader /> : list.length === 0 ? <Empty icon={Users} title="Nenhum atleta" text="Ajuste os filtros de busca." /> : (
        <div className="grid gap-2 md:grid-cols-2">
          {list.map((a) => (
            <Link key={a.user_id} to={`/app/atletas/${a.user_id}`} data-testid={`athlete-row-${a.user_id}`} className="card-x card-hover flex items-center gap-3 p-3">
              <Avatar user={a} size={46} />
              <div className="min-w-0 flex-1">
                <div className="truncate font-semibold">{a.name}</div>
                <div className="mt-0.5 flex items-center gap-2 text-xs text-[#94A3B8]"><LevelBadge level={a.level} />{a.court_side && <span>{a.court_side}</span>}</div>
              </div>
              <div className="text-right"><div className="font-display text-lg font-bold text-[#E4F222]">{a.total_points}</div><div className="text-[10px] text-[#64748B]">pts</div></div>
              <ChevronRight className="h-4 w-4 text-[#64748B]" />
            </Link>
          ))}
        </div>
      )}
      <AthleteForm open={open} onOpenChange={setOpen} onSaved={load} />
    </div>
  );
}
